import { Tabs } from "@shared/primitive-components"
import { AddedFleetEntry } from "../../../api/fleet"
import { AddFleetEntryForm } from "./addFleetEntryForm"
import { FleetEntryCSVUpload } from "./csvUpload"

export type FormAndCSVUploadProps = {
  dataTestId?: string
  addedEntryFormRows: ReadonlyArray<AddedFleetEntry>
  enableBulkUpload?: boolean
  onValidEntriesAdded: (entries: ReadonlyArray<AddedFleetEntry>) => void
}

export const FORM_AND_CSV_UPLOAD_DTI = {
  FORM: `add_to_fleet_form`,
  CSV: `add_to_fleet_csv`,
  TABS: {
    FORM: `add_to_fleet_form_tab`,
    CSV: `add_to_fleet_csv_tab`,
  },
}

export const FormAndCSVUpload = ({
  dataTestId,
  addedEntryFormRows,
  enableBulkUpload,
  onValidEntriesAdded,
}: FormAndCSVUploadProps) => (
  <Tabs.Root defaultValue="form" dataTestId={dataTestId}>
    {enableBulkUpload && (
      <Tabs.List>
        <Tabs.Tab value="form" dataTestId={FORM_AND_CSV_UPLOAD_DTI.TABS.FORM}>
          Quick add
        </Tabs.Tab>
        <Tabs.Tab value="bulk" dataTestId={FORM_AND_CSV_UPLOAD_DTI.TABS.CSV}>
          Bulk upload
        </Tabs.Tab>
      </Tabs.List>
    )}
    <Tabs.Panel value="form">
      <AddFleetEntryForm
        dataTestId={FORM_AND_CSV_UPLOAD_DTI.FORM}
        initialValue={addedEntryFormRows}
        onValidEntriesAdded={onValidEntriesAdded}
      />
    </Tabs.Panel>
    {enableBulkUpload && (
      <Tabs.Panel value="bulk">
        <FleetEntryCSVUpload dataTestId={FORM_AND_CSV_UPLOAD_DTI.CSV} onValidEntriesAdded={onValidEntriesAdded} />
      </Tabs.Panel>
    )}
  </Tabs.Root>
)

FormAndCSVUpload.defaultProps = {
  dataTestId: undefined,
  enableBulkUpload: true,
}
